/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import qs from 'qs';
import classnames from 'classnames';
import dayjs from 'dayjs';
import ArchiveIcon from '@material-ui/icons/Archive';
import Fab from '@material-ui/core/Fab';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/core/Alert';
import ErrorIcon from '@material-ui/icons/Error';
import request from '@/utils/request';
import ButtonML from '@/components/button_ml/ButtonML';
import ModalML from '@/components/modal_ml/ModalML';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';

import IndexStyled from './IndexStyled.jsx';

const MemberManagement = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const searchRef = useRef();
  const { query, pathname } = location;
  // 结构到所有查询条件，包括分页条件
  const {
    channel,
    gender,
    memberCode,
    mobile,
    name,
    signUpDateEnd,
    signUpDateStart,
    registerStore,
    manageStore,
    level,
    hasVip,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;

  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['memberManagement/getMemberList'];
  const { memberPageList, allTotal } = useSelector(
    (state) => state.memberManagement,
  );
  const levels = useSelector((state) => state.memberManagement.levels);
  const treeList = useSelector((state) => state.common.storeTreeList);
  const [modalVisible2, setVisible2] = useState(false);
  const [memberInfo, setMemberInfo] = useState({});

  const [column, setColumn] = useState();
  const [sort, setSort] = useState();
  const [isSearch, setIsSearch] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  // const [idArr, setIdArr] = useState([]);

  const fetchStoreTreeList = useCallback(() => {
    dispatch({
      type: 'common/getStoreTreeList',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  useEffect(() => {
    fetchStoreTreeList();
  }, [fetchStoreTreeList]);

  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    console.log(
      '💢felix => handleSearch => newParam',

      `${pathname}?${qs.stringify({
        ...newParam,

        pageSize,
        pageNum: 1,
      })}`,
    );
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };
  //获取总数据条数
  const fetchDataTotal = useCallback(() => {
    dispatch({
      type: 'memberManagement/getTotalData',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  useEffect(() => {
    fetchDataTotal();
  }, [fetchDataTotal]);

  // 获取会员等级列表
  useEffect(() => {
    dispatch({ type: 'memberManagement/getLevels' });
  }, [dispatch]);

  const fetchData = useCallback(() => {
    let startTime = signUpDateStart;
    let endTime = signUpDateEnd;
    if (signUpDateStart) {
      startTime = dayjs(signUpDateStart).format('YYYY-MM-DD 00:00:00');
    }
    if (signUpDateEnd) {
      endTime = dayjs(signUpDateEnd).format('YYYY-MM-DD 23:59:59');
    }
    const registerStoreArray = registerStore ? registerStore?.split('/') : null;
    const manageStoreArray = manageStore ? manageStore?.split('/') : null;
    const values = {
      channel,
      gender,
      memberCode,
      mobile,
      registerStore: registerStoreArray,
      manageStore: manageStoreArray,
      signUpDateEnd: endTime,
      signUpDateStart: startTime,
      name,
      pageNum,
      pageSize,
      level,
      hasVip: hasVip ? Boolean(Number(hasVip)) : null,
      refreshTime,
      searchCount: false,
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'memberManagement/getMemberList',
      payload: {
        values,
      },
    });
  }, [
    signUpDateStart,
    signUpDateEnd,
    registerStore,
    manageStore,
    dispatch,
    channel,
    gender,
    memberCode,
    mobile,
    name,
    pageNum,
    pageSize,
    level,
    hasVip,
    refreshTime,
  ]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const fetchDataNum = useCallback(() => {
    let startTime = signUpDateStart;
    let endTime = signUpDateEnd;
    if (signUpDateStart) {
      startTime = dayjs(signUpDateStart).format('YYYY-MM-DD 00:00:00');
    }
    if (signUpDateEnd) {
      endTime = dayjs(signUpDateEnd).format('YYYY-MM-DD 23:59:59');
    }
    const registerStoreArray = registerStore ? registerStore?.split('/') : null;
    const manageStoreArray = manageStore ? manageStore?.split('/') : null;
    dispatch({
      type: 'memberManagement/getMemberListNum',
      payload: {
        values: {
          channel,
          gender,
          memberCode,
          mobile,
          registerStore: registerStoreArray,
          manageStore: manageStoreArray,
          signUpDateEnd: endTime,
          signUpDateStart: startTime,
          name,
          pageNum,
          pageSize,
          level,
          hasVip: hasVip ? Boolean(Number(hasVip)) : null,
          refreshTime,
          searchCount: true,
        },
      },
    });
  }, [
    signUpDateStart,
    signUpDateEnd,
    registerStore,
    manageStore,
    dispatch,
    channel,
    gender,
    memberCode,
    mobile,
    name,
    pageNum,
    pageSize,
    level,
    hasVip,
    refreshTime,
  ]);

  // 发起请求
  useEffect(() => {
    fetchDataNum();
  }, [fetchDataNum]);
  // 保存后弹出选择
  const handleOk2 = () => {
    setVisible2(true);
    history.push({
      pathname: '/cm/mm/ml',
      query: { id: memberInfo.id, status: 'edit' },
    });
  };
  // 保存后弹入选择
  const handleCancel2 = () => {
    setVisible2(false);
    fetchData();
  };

  //数据导出
  const handleClickExport = () => {
    let startTime = signUpDateStart;
    let endTime = signUpDateEnd;
    if (signUpDateStart) {
      startTime = dayjs(signUpDateStart).format('YYYY-MM-DD 00:00:00');
    }
    if (signUpDateEnd) {
      endTime = dayjs(signUpDateEnd).format('YYYY-MM-DD 23:59:59');
    }
    const registerStoreArray = registerStore ? registerStore?.split('/') : null;
    const manageStoreArray = manageStore ? manageStore?.split('/') : null;

    const values = {
      channel,
      gender,
      memberCode,
      mobile,
      registerStore: registerStoreArray,
      manageStore: manageStoreArray,
      signUpDateEnd: endTime,
      signUpDateStart: startTime,
      name,
      pageNum,
      pageSize,
      level,
      hasVip: hasVip ? Boolean(Number(hasVip)) : null,
      searchCount: false,
    };
    request('/member/exportData', {
      method: 'POST',
      data: values,
    }).then(() => {
      setAlertOpen(true);
    });
  };
  const handleClose = () => {
    setAlertOpen(false);
  };

  let { data: members, total, hasNext } = memberPageList || {};

  return (
    <IndexStyled>
      <div
        className="mm_content"
        data-log={JSON.stringify({
          oid: 'page_offline_store_customer_management_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
      >
        <div className={classnames('search_group', 'single_component1')}>
          <SearchGroup
            searchRef={searchRef}
            levels={levels}
            query={query}
            treeList={treeList}
            handleSearch={(par) => handleSearch(par)}
            restClick={handleRestClick}
          />
        </div>
        {/* <div className="single_component2">
          <Button
            size="medium"
            fontsize="16px"
            onClick={edit}
            variant="contained"
          >
            新增
          </Button>
        </div> */}
        <div className="export-wrapper">
          <Fab
            variant="extended"
            size="small"
            color="primary"
            aria-label="add"
            className="export"
            onClick={handleClickExport}
          >
            <ArchiveIcon sx={{ width: '24px', height: '24px' }} />
            下载
          </Fab>
        </div>
        <div className={classnames('table_page', 'single_component')}>
          {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
          <TablePage
            pagination={{
              pageNum,
              pageSize,
            }}
            loading={loading}
            total={total}
            allTotal={allTotal}
            tableData={members}
            hasNext={hasNext}
            setPageData={handlePageChange}
            setColumn={(e) => setColumn(e)}
            setSort={(e) => setSort(e)}
          />
        </div>
        <ModalML
          width="30vw"
          title="消息"
          visible={modalVisible2}
          handleOk={handleOk2}
          handleCancel={handleCancel2}
        >
          <div className="editDetail">
            <ButtonML
              size="large"
              value="返回列表"
              fontsize="16px"
              onClick={handleCancel2}
            />
            <ButtonML
              size="large"
              value="编辑详情"
              fontsize="16px"
              onClick={handleOk2}
            />
          </div>
        </ModalML>
      </div>
      <Snackbar
        open={alertOpen}
        autoHideDuration={3000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'top' }}
      >
        <Alert
          severity="info"
          sx={{
            width: '419px',
            backgroundColor: '#E5F6FD',
            fontSize: '14px',
            lineHeight: '22px',
          }}
          iconMapping={{
            info: <ErrorIcon fontSize="inherit" sx={{ color: '#2094D6' }} />,
          }}
        >
          会员数据导出中，可在我的任务查看导出结果
        </Alert>
      </Snackbar>
    </IndexStyled>
  );
};

export default MemberManagement;
